import styled from 'styled-components';

const Container = styled.div`
  opacity: 0;
  display: none;
  z-index: 500;
  box-sizing: border-box;
  position: absolute;
  left: 5%;
  top: 5%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  width: 90%;
  height: 90%;
  background: rgba(255, 255, 255, 0.8);
  color: var(--medium-main);
  font-size: 16px;
  word-break: keep-all;
  line-height: 1.65;
  text-align: center;
  border-radius: 16px;
  backdrop-filter: blur(10px);
  strong {
    font-size: 18px;
  }
  @media all {
    opacity: 1;
    display: flex;
  }
`;

export { Container };
